import React, { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import {
  Button,
  Col,
  Input,
  message,
  notification,
  Row,
  Typography,
} from "antd";

import { useNavigate, useOutletContext } from "react-router-dom";

import PdfModal from "./Component/pdfModel";
import axios from "axios";
import RejectionContent from "./Component/RejectionContent";
import OTPInput from "./Component/OtpInput";
import { confirmOrRejectAppointment } from "../../../api/IndentityApi";
import { Loader, Loader2 } from "lucide-react";

export default function OfferLetter({ current, setCurrent }) {
  const { id, responseData } = useOutletContext();

  const [api, contextHolder] = notification.useNotification();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [reason, setReason] = useState("");
  const type = sessionStorage.getItem("userType");

  const [isRejectTrue, setIsRejectTrue] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [generateLoading, setGenerateLoading] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {}, []);
  const handleClose = () => {
    setIsOpen(false);
    setIsRejectTrue(false);
  };

  // const onInput = (value) => {
  //   console.log("onInput:", value);
  // };
  // const onChange = (text) => {
  //   console.log("onChange:", text);
  // };
  // const sharedProps = {
  //   onChange,
  //   onInput,
  // };

  const handleGenerateOppointment = async () => {
    setGenerateLoading(true);
    const { data } = await axios.post("/api/employees/appointment-letter-pdf", {
      _id: id,
    });

    setGenerateLoading(false);
    if (data?.success) {
      return api.success({
        message: data?.message,
        placement: "top",
      });
    } else {
      return api.error({
        message: data?.message,
        placement: "top",
      });
    }
  };
  const handleOppointment = async () => {
    if (responseData?.offer_letter?.file_url) {
      setPdfUrl(
        responseData?.offer_letter?.file_url?.replace(
          "https://d1k4lem6cjedfg.cloudfront.net",
          "/net"
        )
      );
      setIsOpen(true);
    } else {
      setGenerateLoading(true);
      const { data } = await axios.get("/api/employees/employee-offer-letter");
      setGenerateLoading(false);

      if (data?.success) {
        setPdfUrl(
          data?.data?.offer_letter?.file_url?.replace(
            "https://d1k4lem6cjedfg.cloudfront.net",
            "/net"
          )
        );

        setIsOpen(true);
      } else {
        return api.error({
          message: data?.message,
          placement: "top",
        });
      }
    }
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    const { data } = await confirmOrRejectAppointment({
      accept: true,
      reject: false,
    });

    setIsLoading(false);

    if (data?.success) {
      setIsOpen(false);
      setIsOtpSent(true);
    } else {
      setIsOtpSent(false);
      return api.error({
        message: data?.message,
        placement: "top",
      });
    }
  };

  const handleReject = async () => {
    setIsRejecting(true);
    const { data } = await confirmOrRejectAppointment({
      accept: false,
      reject: true,
      reason,
    });

    setIsRejecting(false);

    if (data?.success) {
      setIsOpen(false);
      return api.success({
        message: data?.message,
        placement: "top",
      });
    } else {
      setIsOtpSent(false);
      return api.error({
        message: data?.message,
        placement: "top",
      });
    }
  };

  const handleVerifyOTP = async () => {
    const otpString = otp.join("");

    setIsVerifying(true);
    const { data } = await axios.post("/api/employees/verify-offer", {
      otp: otpString,
    });

    setIsVerifying(false);
    if (data?.success) {
      setIsOtpSent(false);
      return api.success({
        message: data?.message,
        placement: "top",
      });
    } else {
      setIsOtpSent(false);
      return api.error({
        message: data?.error,
        placement: "top",
      });
    }
  };

  return (
    <>
      {contextHolder}

      <div className="align-content-start  w-full ">
        <div>
          <h3 className="color-heading mt-4 mb-3">
            {type === "admin"
              ? "Generate Offer Letter"
              : "Your Joining Forms have been approved by HR."}
          </h3>
          <div>
            <div className="flex">
              {type === "admin" ? (
                <>
                  {(responseData?.offer_status?.offer_verified !== true && (
                    <button
                      type="button"
                      onClick={handleGenerateOppointment}
                      disabled={generateLoading}
                      className="bg-[#00a0e4] self-center mb-5 mt-4 text-white px-3 py-1 rounded flex items-center"
                    >
                      Generate Appointment Letter{" "}
                      {generateLoading && (
                        <span className="w-3 ml-2">
                          <Loader2 className="animate-spin" />
                        </span>
                      )}
                    </button>
                  )) || (
                    <button
                      type="button"
                      disabled={generateLoading}
                      onClick={handleOppointment}
                      className="bg-[#00a0e4] self-center mb-5 mt-4 text-white px-3 py-1 rounded flex items-center"
                    >
                      View Appointment Letter{" "}
                      {generateLoading && (
                        <span className="w-3 ml-2">
                          <Loader2 className="animate-spin" />
                        </span>
                      )}
                    </button>
                  )}
                </>
              ) : (
                <>
                  <button
                    type="button"
                    disabled={generateLoading}
                    onClick={handleOppointment}
                    className="bg-[#00a0e4] self-center mb-5 mt-4 text-white px-3 py-1 rounded flex items-center"
                  >
                    View Appointment Letter{" "}
                    {generateLoading && (
                      <span className="w-3 ml-2">
                        <Loader2 className="animate-spin" />
                      </span>
                    )}
                  </button>
                </>
              )}
            </div>
          </div>
          {isOtpSent && (
            <div className="flex w-full justify-between">
              <div>
                {" "}
                <h3 className="color-heading mt-4 mb-3">
                  Confirm & Sign via OTP
                </h3>
                <p>We’ll send an OTP to your mobile number</p>
              </div>
              <div>
                <div>
                  <div className="flex justify-between">
                    {" "}
                    <p className="mb-1 text-xs">Enter OTP</p>
                    <p className="mb-1 text-xs text-red-500">Resend</p>
                  </div>

                  <OTPInput otp={otp} onChange={setOtp} />
                  <div className="flex justify-end">
                    <Button
                      type="button"
                      loading={isVerifying}
                      onClick={handleVerifyOTP}
                      className="bg-[#00a0e4] self-center mb-5 mt-4 text-white px-3 py-1 rounded flex items-center"
                    >
                      Confirm & Sign
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}{" "}
        </div>
        {/* <Col className={`px-3 mb-4 text-justify`} span={24}>
            <h2 class="text-[#00a0e4] font-bold text-xl flex items-center">
              <span class="w-1 h-full bg-[#00a0e4] mr-2">|</span>
              Annexures
            </h2>
          </Col>
          <button
            type="button"
            className="bg-[#00a0e4] text-white px-3 py-1 rounded flex items-center"
          >
            <i className="mr-1">📄</i> Read
          </button> */}
      </div>

      <PdfModal
        isOpen={isOpen}
        onClose={handleClose}
        pdfUrl={!isRejectTrue ? pdfUrl : null}
      >
        <div className="justify-between pt-3 items-center">
          <div>
            {(isRejectTrue && (
              <RejectionContent
                reason={reason}
                setReason={setReason}
                handleReject={handleReject}
                isLoading={isRejecting}
                responseData={responseData}
              />
            )) || (
              <>
                {(responseData?.offer_status?.offer_verified !== true && (
                  <div>
                    <Button
                      loading={isLoading}
                      onClick={handleConfirm}
                      type="fill"
                      className="bg-green-600 text-white"
                    >
                      <span className="mr-2">
                        <svg
                          width="18"
                          height="12"
                          viewBox="0 0 18 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 6L6.33371 11L17 1"
                            stroke="white"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      Confirm & Sign via OTP
                    </Button>

                    <Button
                      type="fill"
                      onClick={() => setIsRejectTrue(true)}
                      className="bg-red-600 text-white"
                    >
                      <span className="mr-2">
                        <svg
                          width="11"
                          height="11"
                          viewBox="0 0 11 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.210117 9.77539C-0.0700391 10.0556 -0.0700391 10.5097 0.210117 10.7899C0.490274 11.07 0.944508 11.07 1.22466 10.7899L0.210117 9.77539ZM6.00726 6.00726C6.28742 5.72709 6.28742 5.27293 6.00726 4.99277C5.72709 4.7126 5.27293 4.7126 4.99277 4.99277L6.00726 6.00726ZM4.99277 4.99277C4.7126 5.27293 4.7126 5.72709 4.99277 6.00726C5.27293 6.28742 5.72709 6.28742 6.00726 6.00726L4.99277 4.99277ZM10.7899 1.22466C11.07 0.944508 11.07 0.490274 10.7899 0.210117C10.5097 -0.0700391 10.0556 -0.0700391 9.77539 0.210117L10.7899 1.22466ZM6.00726 4.99277C5.72709 4.7126 5.27293 4.7126 4.99277 4.99277C4.7126 5.27293 4.7126 5.72709 4.99277 6.00726L6.00726 4.99277ZM9.77539 10.7899C10.0556 11.07 10.5097 11.07 10.7899 10.7899C11.07 10.5097 11.07 10.0556 10.7899 9.77539L9.77539 10.7899ZM4.99277 6.00726C5.27293 6.28742 5.72709 6.28742 6.00726 6.00726C6.28742 5.72709 6.28742 5.27293 6.00726 4.99277L4.99277 6.00726ZM1.22466 0.210117C0.944508 -0.0700391 0.490274 -0.0700391 0.210117 0.210117C-0.0700391 0.490274 -0.0700391 0.944508 0.210117 1.22466L1.22466 0.210117ZM1.22466 10.7899L6.00726 6.00726L4.99277 4.99277L0.210117 9.77539L1.22466 10.7899ZM6.00726 6.00726L10.7899 1.22466L9.77539 0.210117L4.99277 4.99277L6.00726 6.00726ZM4.99277 6.00726L9.77539 10.7899L10.7899 9.77539L6.00726 4.99277L4.99277 6.00726ZM6.00726 4.99277L1.22466 0.210117L0.210117 1.22466L4.99277 6.00726L6.00726 4.99277Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                      I Do Not Wish to Proceed
                    </Button>
                  </div>
                )) || (
                  <>
                    {type !== "admin" && (
                      <div className="flex justify-end text-green-600 font-bold">
                        Offer Letter Accepted
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </PdfModal>
    </>
  );
}
